function initTomSelectFilters() {
  const selects = document.querySelectorAll('.js-searchable-filter');

  selects.forEach((select) => {
    if (select.tomselect) return;

    new TomSelect(select, {
      create: false,
      allowEmptyOption: true,
      maxOptions: 500,
      placeholder: 'Search...',
      searchField: ['text'],
      plugins: ['dropdown_input'],
      onChange: function() {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initTomSelectFilters);
document.addEventListener('shopify:section:load', initTomSelectFilters);